import React from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import ManuscriptContentView from "../../ManuscriptContentView";

/**
 * ColumnsBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Columns block renderer
 *
 * @param {*} props
 */
const ColumnsBlock = props => (
  <div>
    <Grid>
      <Grid.Row>
        <Grid.Column width={8}>
          <ManuscriptContentView
            contentBlocks={props.block.blocksLeft}
            updateDocument={updatedBlocks =>
              props.onChange({ ...props.block, blocksLeft: updatedBlocks })
            }
            isReadOnlyMode={props.isReadOnlyMode}
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <ManuscriptContentView
            contentBlocks={props.block.blocksRight}
            updateDocument={updatedBlocks =>
              props.onChange({ ...props.block, blocksRight: updatedBlocks })
            }
            isReadOnlyMode={props.isReadOnlyMode}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

ColumnsBlock.propTypes = {
  /**
   * block: {url}
   * Contains the content block information
   */
  block: PropTypes.shape({
    blocksLeft: PropTypes.arrayOf(PropTypes.shape({})),
    blocksRight: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default ColumnsBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/layout/ColumnsBlock.js